import React, { useState } from 'react';
import { RecordContextProvider, ReferenceManyField, ResourceContextProvider, useRefresh, useTranslate } from 'react-admin';
import { TableRow, TableCell, Collapse, IconButton, CardContent, CardActions, makeStyles, useMediaQuery } from '@material-ui/core'
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';

import { isAuthorized } from '../../../../common/Authorize';

import { MessageGrid } from '../../../messages/MessageGrid';
import { MessageForm } from '../../../messages/MessageForm';
import { useParticipant } from '../../../../http';
import { useAssignmentsContext } from './AssignmentsContext';

const useStyles = makeStyles(theme => ({
  actions: {
    padding: 0,
  },
  form: {
    width: '100%',
  }
}))

const GameMessages = ({ game, settings, type = 'Officiating', showCreate = false, ...props }) => {
  const classes = useStyles();
  const translate = useTranslate();

  if (!game) return null;

  const recipients = type === 'League'
    ? translate('resources.games.labels.assignment.team_officials').toLowerCase()
    : translate('resources.games.labels.assignment.assigners').toLowerCase();
  const helperText = translate('resources.games.helpers.assignment.notification_will_be_sent', { recipients })

  return <>
    <CardContent>
      <ReferenceManyField
        reference="gameMessages"
        target="games"
        label={translate('resources.gameMessages.name', 2)}
        filter={{ type }}
        sort={{ field: 'createdAt', order: 'ASC' }}
      >
        <MessageGrid type={type} />
      </ReferenceManyField>
    </CardContent>
    {showCreate && <CardActions className={classes.actions}>
      <ResourceContextProvider value="gameMessages">
        <RecordContextProvider value={null}>
          <MessageForm className={classes.form} initialValues={{ gameId: game.id, type }} helperText={helperText} />
        </RecordContextProvider>
      </ResourceContextProvider>
    </CardActions>}
  </>
}

const useMessagesStyles = makeStyles(theme => ({
  toggleCell: {
    width: theme.spacing(22),
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      width: 30,
    },
    borderBottom: 0,
  },
  cell: {
    borderBottom: 0,
  },
}))

export default () => {
  const translate = useTranslate();
  const { game, assignments, settings } = useAssignmentsContext()
  const participantId = useParticipant()
  const [ isOpen, setOpen ] = useState(false);
  const small = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const refresh = useRefresh()
  const classes = useMessagesStyles();

  const enabled = settings && settings.enabled && settings.status === 'Active'

  const isAssigned = assignments.some(assignment => assignment.participantId === participantId && ['assigned', 'confirmed'].includes(assignment.status))
  const canViewMessages = isAuthorized(game, 'gameMessagesOfficiating', 'list');
  const canCreateMessages = isAuthorized(game, 'gameMessagesOfficiating', 'create') || isAssigned;
  if (!canViewMessages || !enabled) return null;

  const onClose = () => {
    setOpen(false);
  }

  const editProps = {
    basePath: '/gameMessages',
    hasEdit: true,
    id: game.id,
    resource: 'gameMessages',
    undoable: false,
    onSuccess() {
      onClose();
      refresh();
    },
  }
  return <>
    <TableRow onClick={() => setOpen(!isOpen)}>
      <TableCell className={classes.toggleCell}>
        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!isOpen)}>
          {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
        {!small ? ` ${translate('resources.gameMessages.name', 2)}` : ''}
      </TableCell>
      <TableCell className={classes.cell}>
        {small && <div>{translate('resources.gameMessages.name', 2)}</div>}
        {!isOpen && translate('resources.games.messages.assignment.contact_game_assigners_officials')}
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell colSpan={2} style={{ padding: 0 }}>
        <Collapse in={isOpen}>
          {isOpen && <GameMessages game={game} settings={settings} showCreate={canCreateMessages} {...editProps} onClose={onClose} />}
        </Collapse>
      </TableCell>
    </TableRow>
  </>
}
